export default {
  pageHeroV1: {
    container: {
      height: '50vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'flex-end',
      justifyContent: 'flex-start'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      h1: {
        fontSize: ['2.5rem', '', '3.5rem'],
        marginBottom: 1,
        letterSpacing: '3px',
        textTransform: 'uppercase',
        color: 'secondary',
        borderColor: 'secondary',
        backgroundColor: 'rgba(0,0,0,0.35)',
        padding: '1rem'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
